import React from 'react'
import { Form } from 'react-bootstrap'
import FormInputSwitch, { IFormInputSwitchProps } from './FormInputSwitch'

const LabeledFormInput: React.FC<IFormInputSwitchProps> = ({
  input,
  onChange,
  onEntered,
}) => {
  return (
    <Form.Group className={'mb-3'}>
      <Form.Label>{input.title}</Form.Label>
      <FormInputSwitch input={input} onChange={onChange} onEntered={onEntered} />
    </Form.Group>
  )
}
export default LabeledFormInput
